<template>
    <div class="bg-dark-tp" :class="nomineesDataStatus ? 'min-h-screen' : 'xh-svh'">
        <div 
            class="max-w-full sm:max-w-md flex flex-col mx-auto inset-y-0 right-0 py-5 border-r-0 sm:border-r border-l-0 sm:border-l border-gray-900 font-satoshi_r"
            :class="nomineesDataStatus ? 'justify-start min-h-screen' : 'justify-end xh-svh bg-award'"
        >
            <div>
                <component 
                    :is="isComponent"
                    :formData="formData"
                    :nomineesData="nomineesData"
                    @callback="checkemitted()"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { getHandler } from "@/api/requestHandler";

    import Loader from "@/components/trendUpp/IsLoading.vue";
    import AlreadyVoted from "@/components/trendUpp/AlreadyVoted.vue";
    import Nominees from "@/components/trendUpp/Nominees.vue";
    import NotFound from "@/components/trendUpp/NotFound.vue";

    export default {
        name: "TrendUppVote",

        components: {
            Loader,
            AlreadyVoted,
            Nominees,
            NotFound,
        },

        data() {
            return {
                nomineesData: [],
                nomineesDataStatus: false,

                isComponent: 'Loader',
                formData: null,
            }
        },

        methods: {
            async verifyUser() {
                if (
                    !this.$route.query?.id || 
                    this.$route.query?.id == '' || 
                    this.$route.query?.id == 'undefined'
                ) {
                    this.getNotFound('undefined');
                    
                } else {
                    let response = await getHandler(`/customer/polls/trendupp/vote-status?id=${this.$route.query?.id}`)
                    
                    if (response.status === 200 && response.data.success) {
                        if (response.data.data?.voted) {
                            this.isComponent = 'AlreadyVoted';

                        } else { 
                            this.fetchNominees(); 
                        }
                    } else { 
                        this.getNotFound('custom', response.data?.data);
                    }                     
                }
            },

            async fetchNominees() {
                this.nomineesData = [];

                let response = await getHandler(`/customer/polls/trendupp/candidates`)

                if (response.status === 200 && response.data.success) {
                    response.data?.data?.items.forEach(
                        (item) => this.nomineesData.push(item)
                    )

                    if (this.nomineesData?.length > 0) {
                        this.nomineesDataStatus = true;
                        this.isComponent = 'Nominees';
                        
                    } else {
                        this.getNotFound();
                    }
                } else { 
                    this.getNotFound('custom', response.data?.data);
                }
            },

            checkemitted(payload) {
                if (payload?.errorName == 'custom') {
                    this.getNotFound(payload.errorName, payload.data);

                } else {
                    this.getNotFound(payload.errorName);
                }
            },

            getNotFound(status, data) {
                if (status == 'custom') {
                    this.formData = {
                        title: data?.header,
                        subtitle: data?.message,
                        buttonName: data?.button_text,
                        destination: data?.destination,
                        buttonLink: data?.destination == 'email'? 'mailto:' : 'https://sycamoreng.onelink.me/Qthc/9lrl1bvq'
                    }

                } else if (status == 'undefined') {
                    this.formData = {
                        title: 'Open App to Vote',
                        subtitle: 'To cast your vote, kindly go to the app. Click the button below to open the app.',
                        buttonName: 'Open App',
                        destination: 'App',
                        buttonLink: 'https://sycamoreng.onelink.me/Qthc/9lrl1bvq'
                    }
                    
                } else {
                    this.formData = {
                        title: 'Something went wrong!',
                        subtitle: 'An error occurred, please click the button below to try again or go back.',
                        buttonName: 'Ok',
                        destination: '',
                        buttonLink: '',
                    }
                }

                this.isComponent = 'NotFound';
            },

            addGoogleAnalyticsScript() {
                const script = document.createElement('script');
                script.id = 'google-analytics';
                script.async = true;
                script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MY745CXBPJ';
                document.head.appendChild(script);

                const inlineScript = document.createElement('script');
                inlineScript.text = `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-MY745CXBPJ');
                `;
                document.head.appendChild(inlineScript);
            }
        },

        mounted() {
            this.verifyUser();
            this.addGoogleAnalyticsScript();
        },

        beforeDestroy() {
            const gaScript = document.getElementById('google-analytics');
            if (gaScript) {
                gaScript.remove();
            }
        }
    };
</script>

<style scoped>
    body {
        background-color: #000000;
    }

    .xh-svh {
        height: 100vh;
        height: 100svh !important;
    }

    .xh-vh {
        height: 100vh !important;
    }

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .bg-award {
        background-image: url("../../assets/images/trendupp/awards_01.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center bottom;
    }
</style>

